<script>
export default {
  name: 'NewYearComponent',
  data () {
    return {
      showMessage: false
    }
  },
  methods: {
    closeMessage () {
      this.showMessage = false
      // Устанавливаем флаг в LocalStorage
      localStorage.setItem('newYearMessageSeen2026', 'true')
    }
  },
  mounted () {
    // Проверяем текущую дату
    const now = new Date()
    const start = new Date('2025-12-25')
    const end = new Date('2026-01-14')

    if (now >= start && now <= end) {
      // Проверяем LocalStorage
      const hasSeenMessage = localStorage.getItem('newYearMessageSeen2026')
      if (!hasSeenMessage) {
        this.showMessage = true
      }
    }
  }
}
</script>

<template>
  <v-dialog :fullscreen="$vuetify.breakpoint.xs" v-model="showMessage" max-width="500">
    <v-card class="custom-card">
      <v-btn
        @click="closeMessage"
        style="right: 0"
        absolute
        icon
        color="white"
        large>
        <v-icon>mdi-close</v-icon>
      </v-btn>
      <div class="new-y-title text-center text-white">
        <h1 class="text-white">Веселого Різдва та </h1>
        <h1 class="text-white">щасливого Нового року</h1>
        <h1 class="text-white">2026</h1>
      </div>
      <v-card-text class="new-y-text pb-2 pt-4">
        <b>Шановні клієнти!</b><br>
        <br>
        Щиро вітаємо вас із прийдешніми новорічними та різдвяними святами!<br>
        Нехай цей святковий час наповнить ваші серця радістю, а домівки — теплом і затишком.
        <br> Бажаємо вам міцного здоров’я, щастя, добробуту та, найголовніше, мирного неба над головою.
        <br><br>
        <b>Звертаємо вашу увагу</b>, що ми відновлюємо роботу 5 січня. Ми завжди раді вам і готові забезпечити найкращий сервіс та продукцію.
        <br>
        Дякуємо, що обираєте нас. Разом до кращого майбутнього!<br>
        <br>
        З найтеплішими побажаннями,<br>
        Команда компанії "Еталон"
        <div><v-btn class="mt-2" width="100%" color="primary" text @click="closeMessage">Закрити</v-btn></div>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<style lang="scss">
.new-y-title {
  padding: 20px;
  background-image: url('https://i.pinimg.com/736x/a3/48/19/a34819d3a9c332cf5780a4e2a9386367.jpg'); /* Ссылка на изображение */
  background-size: cover; /* Масштабирование изображения */
  //background-position: center; /* Центрирование изображения */
  @media only screen and (max-width: 600px) {
    h1 {
      font-size: 1.6rem!important;
    }
  }
}
.new-y-text {
  background: white;
  font-size: 14px;
}
.text-white {
  color: white;
}
</style>
